/* eslint-disable no-unused-vars */
/* eslint-disable  react/jsx-indent */
/* eslint-disable  react/jsx-indent-props */
/* eslint-disable  react/no-unescaped-entities */
/* eslint-disable */

import React, { useEffect, useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import _ from 'lodash';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import { connect } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { getType, getManagePermission } from '../helper';
import Aside from '../components/Aside';
import { parseString } from 'utils/parseString';
import { getInitConfig } from 'lib/tiny-mce';
import * as actions from '../../cms/action';
import * as c from '../../cms/constant';

const UpdateBusinessPermit = ({
  id,
  updating,
  getList,
  update,
  itemSettings,
  setFormData,
  formData,
  //   htmlToDraft,
  //   convertToRaw,
  //   draftToHtml,
  //   active,
  history,
  match,
}) => {
  const [content, setContent] = useState('');
  const [placeholderImg, setPlaceholderImg] = useState('');
  const [checkedItems, setCheckedItems] = useState([]);
  const editorRef = useRef(null);
  const permit = _.get(match, 'params.permit', '');
  const permissions = getJson('permissions');
  const canManage = Acl(permissions, [getManagePermission(permit)]);

  const parsedData = useMemo(() => {
    if (!itemSettings) return {};
    const parsedItem = parseString(itemSettings);
    const attrib = _.get(parsedItem, 'attributes', {});
    return attrib;
  }, [itemSettings]);
  const cmsId = useMemo(() => {
    if (!itemSettings) return 0;
    const parsedItem = parseString(itemSettings);
    const attrib = _.get(parsedItem, 'id', 0);
    return +attrib;
  }, [itemSettings]);
  const body = _.get(parsedData, 'body', '[]');
  const dataBody = useMemo(() => {
    const parsedBody = parseString(body);
    return parsedBody;
  }, [body]);
  const paperSetup = _.get(dataBody?.[id], 'paper_setup', {});

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    let newCheckedItems;

    if (checked) {
      newCheckedItems = [...checkedItems, name];
    } else {
      newCheckedItems = checkedItems.filter((i) => i !== name);
    }

    setCheckedItems(newCheckedItems);

    if (editorRef.current) {
      const editor = editorRef.current;
      if (checked) {
        editor.insertContent(`[${name}]`);
      } else {
        const currentContent = editor.getContent();
        const updatedContent = currentContent.replace(`[${name}]`, '');
        editor.setContent(updatedContent);
      }
    }
  };

  useEffect(() => {
    if (permit) {
      try {
        getList({ type: getType(permit) });
      } catch (error) {
        console.error('Error loading settings:', error);
      }
    }
  }, [permit]);

  useEffect(() => {
    if (itemSettings) {
      let retrievedData = _.get(dataBody, id) || '{}';

      setCheckedItems(retrievedData.items ?? []);

      setFormData({
        id: _.get(itemSettings, 'id'),
      });
    }
  }, [JSON.stringify(itemSettings)]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    let payload = {
      selected: true,
      body: content,
      items: checkedItems,
      placeholderImg: placeholderImg,
    };

    payload = _.omitBy(payload, _.isEmpty);

    dataBody[id] = { ...dataBody[id], ...payload };

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        // type: getType(permit),
        body: JSON.stringify(dataBody),
      });
    }
  };

  if (!canManage) {
    return <Redirect to={`/general-settings/templates/${permit}`} />;
  }

  return (
    <form
      onSubmit={handleOnSubmit}
      className="d-flex overflow-hidden"
      style={{ gap: '10px' }}
    >
      <div
        className="border rounded bg-white p-2 w-27"
        style={{ overflow: 'auto' }}
      >
        <div className="mb-3">
          <Aside
            paperSetup={paperSetup}
            parsedData={parsedData}
            cmsId={cmsId}
          />
        </div>

        <div
          className="d-flex align-items-center justify-content-between gap-2"
          style={{ gap: '10px' }}
        >
          <div className="alert alert-primary" role="alert">
            <div className="d-flex align-items-center" style={{ gap: '20px' }}>
              <div className="fa fa-info" />
              Check the following items below to be included in the customized
              template.
            </div>
          </div>
        </div>

        <table className="table table-bordered table-sm mb-0">
          <tbody>
            {c.PERMIT_APPLICATIONS.sort((a, b) => a.localeCompare(b)).map(
              (key) => (
                <tr key={key}>
                  <td className="bg-light" colSpan={2}>
                    <label style={{ marginBottom: '0px' }}>
                      <input
                        type="checkbox"
                        name={key}
                        checked={checkedItems.includes(key)}
                        onChange={handleCheckboxChange}
                      />
                      <span style={{ fontSize: '14px', marginLeft: '4px' }}>
                        {_.startCase(_.toLower(key.replace(/_/g, ' ')))}
                      </span>
                    </label>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>

      <div className="w-73 d-flex flex-column" style={{ minHeight: 0 }}>
        <div className="alert alert-primary" role="alert">
          <div className="d-flex align-items-center" style={{ gap: '20px' }}>
            <div className="fa fa-info" />
            FOR THE SELECTED/ACTIVE TEMPLATE: To use the default pre-defined
            template, click the Customize Template button then update the
            "Status" of the customized template and Save.
          </div>
        </div>

        <Editor
          key={JSON.stringify(paperSetup)}
          lassName="flex-grow-1"
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={(dataBody[id] || {}).body ?? ''}
          apiKey={process.env.REACT_APP_TINY_MCE_KEY}
          init={getInitConfig(paperSetup)}
          onEditorChange={(newValue) => {
            if (newValue.includes('.placeImage')) {
              const extractBackgroundImageUrl = (html) => {
                // Extract style contents
                const styleContent =
                  html.match(/<style[^>]*>([\s\S]*?)<\/style>/gi) || [];
                // Find URL in .placeImage class
                const urlMatch = styleContent
                  .join(' ')
                  .match(
                    /\.placeImage\s*\{\s*background-image:\s*url\(['"]([^'"]+)['"]\)/i
                  );
                return urlMatch ? urlMatch[1] : null;
              };

              const backgroundImageUrl = extractBackgroundImageUrl(newValue);
              setPlaceholderImg(backgroundImageUrl);
            }
            setContent(newValue);
          }}
        />

        <div className="d-flex justify-content-center">
          <button
            onClick={() =>
              history.push(`/general-settings/templates/${permit}`)
            }
            type="button"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">Back</span>
          </button>
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>
          </button>
        </div>
      </div>
    </form>
  );
};

UpdateBusinessPermit.propTypes = {
  id: PropTypes.string.isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  itemSettings: PropTypes.instanceOf(Object).isRequired,
  //   htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  //   convertToRaw: PropTypes.instanceOf(Function).isRequired,
  //   draftToHtml: PropTypes.instanceOf(Function).isRequired,
  //   active: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match }) => {
  return {
    id: _.get(match, 'params.id') || '',
    itemSettings: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
    updating: api.loading.indexOf(c.UPDATE_SETTING) > -1,
  };
};

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(UpdateBusinessPermit);
